<template lang="pug">
    p(:class="{'mb': marginBottom, 'ml': marginLeft}")
      b(:class="blackLabel ? 'blackLabel' : ''") {{ label }}
      br(v-if="isContentInNextLine")
      span(v-if="textIcon !== ''")
        el-tooltip.item(
          effect='dark',
          :content='textIcon',
          :placement="toolTip"
        )
          span(slot="content", v-html="textIcon")
          font-awesome-icon.icon(icon="info-circle" size="1x")
      span.text(v-if="content && !isContentInNextLine", :class="{'float-right': contentAlignRight}")  &nbsp {{formataContent(content)}}
      span.text(v-if="content && isContentInNextLine", :class="{'float-right': contentAlignRight}", v-html="formataContent(content)")
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    content: {
      type: [String, Number, Array]
    },
    marginBottom: {
      type: Boolean,
      default: false
    },
    marginLeft: {
      type: Boolean,
      default: false
    },
    textIcon: {
      type: String,
      default: ''
    },
    toolTip: {
      type: String,
      default: 'left'
    },
    contentAlignRight: {
      type: Boolean,
      default: false
    },
    blackLabel: {
      type: Boolean,
      default: false
    },
    isContentInNextLine: {
      type: Boolean,
      default: false
    },
    isArray: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    formataContent (content) {
      if (this.isArray) {
        return content?.length ? content.join().replace(/,/g, ' / ') : '-'
      }
      return content
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.float-right {
  float: right;
}

.mb {
  margin-bottom: 2vh;
}

.ml {
  margin-left: 15px;
}

.text {
  color: $font-color;
}

p {
  margin-bottom: 1vh;
  font-size: 14px;
  b {
    color: $font-dark-color;
    span{
      font-weight: normal !important;
    }
  }
}

.icon {
  margin-left: 2px;
  margin-right: 2px;
  color: #b2b6be;
}

.blackLabel {
  color: black
}
</style>



// WEBPACK FOOTER //
// src/components/AppDisplay.vue